export default __webpack_public_path__ + "static/Blind-angels-dazon-woman-holding-hands-2b1bc3d6e14f522aff0c89401c9426b7.png";